"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectImportLog = void 0;
const typeorm_1 = require("typeorm");
const JournaledEntity_1 = require("../../JournaledEntity");
const User_1 = require("../../user/entity/User");
let ProjectImportLog = class ProjectImportLog extends JournaledEntity_1.JournaledEntity {
    constructor(init) {
        super();
        Object.assign(this, init !== null && init !== void 0 ? init : {});
    }
};
exports.ProjectImportLog = ProjectImportLog;
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], ProjectImportLog.prototype, "year", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Number)
], ProjectImportLog.prototype, "month", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => User_1.User),
    __metadata("design:type", User_1.User)
], ProjectImportLog.prototype, "issuer", void 0);
__decorate([
    (0, typeorm_1.RelationId)((r) => r.issuer),
    __metadata("design:type", String)
], ProjectImportLog.prototype, "issuerId", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'jsonb' }),
    __metadata("design:type", Array)
], ProjectImportLog.prototype, "importData", void 0);
exports.ProjectImportLog = ProjectImportLog = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], ProjectImportLog);
